import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Stack } from "@mui/joy";
import DefaultPage from "pages/container/DefaultPage";
import useIsInappWebview from "hooks/useIsInappWebview";
import { sendMessage } from "utils/webview";
import { useConfirmTossPaymentsPlanUpgrade } from "../../hooks/useConfirmTossPaymentsPlanUpgrade";

export default function TossPaymentsPlanUpgradeSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();

  const {
    mutate: confirmPayments,
    isLoading,
    isSuccess,
    isError,
  } = useConfirmTossPaymentsPlanUpgrade();

  useEffect(() => {
    const orderId = searchParams.get("orderId");
    const paymentKey = searchParams.get("paymentKey");
    const payAmount = Number(searchParams.get("amount"));
    const previousPlan = searchParams.get("previous_plan");
    const newPlan = searchParams.get("new_plan");

    if (orderId && paymentKey && payAmount && previousPlan && newPlan) {
      // 결제 확인 API 호출
      confirmPayments(
        { orderId, paymentKey, payAmount, previousPlan, newPlan },
        {
          onSuccess: () => {
            // 결제 성공 후 재진입 시 결제 페이지의 page view 관련 이벤트(meta, firebase, appsflyer, mixpanel) 전송을 1회 차단
            try {
              localStorage.setItem("suppress_payment_page_view", "1");
            } catch (e) {}
            if (isInappWebview) {
              sendMessage(
                JSON.stringify({
                  event: "toss_payments",
                  params: {
                    status: "success",
                  },
                })
              );
            } else {
              navigate("/", { replace: true });
            }
          },
        }
      );
    }
  }, []);

  // 로딩/성공/실패 UI 렌더
  if (isLoading) {
    return (
      <DefaultPage
        content={
          <Stack alignItems="center">
            <CircularProgress color="neutral" />
          </Stack>
        }
      />
    );
  }

  if (isError) {
    return (
      <DefaultPage
        content={
          <Stack alignItems="center">결제 처리 중 오류가 발생했습니다.</Stack>
        }
      />
    );
  }

  if (isSuccess) {
    // onSuccess에서 이미 로직 수행 → 잠시 로딩 UI 표시 가능
    return (
      <DefaultPage
        content={
          <Stack alignItems="center">
            <CircularProgress color="neutral" />
          </Stack>
        }
      />
    );
  }

  return null;
}
